import { Value } from '@helo/utils';
const isFilterMatch = (objectFilter) => (inputObject) => {
    if (!inputObject || typeof inputObject !== 'object') {
        return false;
    }
    for (const key of Object.keys(objectFilter)) {
        const filterInput = objectFilter[key];
        const inputValue = inputObject[key];
        for (const filterKey in filterInput) {
            switch (filterKey) {
                case 'equals':
                    if (inputValue !== filterInput.equals) {
                        return false;
                    }
                    break;
                case 'in':
                    if ('in' in filterInput &&
                        !filterInput.in?.includes(inputValue)) {
                        return false;
                    }
                    break;
                case 'notIn':
                    if ('notIn' in filterInput &&
                        filterInput.notIn?.includes(inputValue)) {
                        return false;
                    }
                    break;
                case 'lt':
                    if ('lt' in filterInput &&
                        !Value.isNullable(filterInput.lt) &&
                        inputValue >= filterInput.lt) {
                        return false;
                    }
                    break;
                case 'lte':
                    if ('lte' in filterInput &&
                        !Value.isNullable(filterInput.lte) &&
                        inputValue > filterInput.lte) {
                        return false;
                    }
                    break;
                case 'gt':
                    if ('gt' in filterInput &&
                        !Value.isNullable(filterInput.gt) &&
                        inputValue <= filterInput.gt) {
                        return false;
                    }
                    break;
                case 'gte':
                    if ('gte' in filterInput &&
                        !Value.isNullable(filterInput.gte) &&
                        inputValue < filterInput.gte) {
                        return false;
                    }
                    break;
                case 'contains':
                    if ('contains' in filterInput &&
                        !Value.isNullable(filterInput.contains) &&
                        !inputValue.includes(filterInput.contains)) {
                        return false;
                    }
                    break;
                case 'startsWith':
                    if ('startsWith' in filterInput &&
                        !Value.isNullable(filterInput.startsWith) &&
                        !inputValue.startsWith(filterInput.startsWith)) {
                        return false;
                    }
                    break;
                case 'endsWith':
                    if ('endsWith' in filterInput &&
                        !Value.isNullable(filterInput.endsWith) &&
                        !inputValue.endsWith(filterInput.endsWith)) {
                        return false;
                    }
                    break;
            }
        }
    }
    return true;
};
export const Filter = {
    isFilterMatch,
};
//# sourceMappingURL=filter.js.map